import apiClient from './apiClient';

export const jobsApi = {
  list: (params) => apiClient.get('/jobs/', { params }),
  get: (id) => apiClient.get(`/jobs/${id}/`),
  create: (data) => apiClient.post('/jobs/', data),
  update: (id, data) => apiClient.patch(`/jobs/${id}/`, data),
  remove: (id) => apiClient.delete(`/jobs/${id}/`),
  run: (id) => apiClient.post(`/jobs/${id}/run/`),
  auditLogUrl: (id) => `${apiClient.defaults.baseURL}/jobs/${id}/audit-log/`,
  reportUrl: (id) => `${apiClient.defaults.baseURL}/jobs/${id}/report/`,
};

export const authApi = {
  status: () => apiClient.get('/auth/status/'),
  csrf: () => apiClient.get('/auth/csrf/'),
  login: (username, password) => apiClient.post('/auth/login/', { username, password }),
  logout: () => apiClient.post('/auth/logout/'),
};
